{
    "EnablerptrequestauditLabel": "Activer la sortie d'audit de la demande de rapport :",
    "Audit_SectionHeader": "Audit",
    "Audit_SectionPara": "Avertissement : N'activez le paramètre suivant que si un membre de l'équipe d'administration ou d'assistance de votre application vous le demande.",
    "NAME": "Audit"
}